<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import api from '@/helpers/api'
const MODEL_TYPES = [
  'full_seat',
  'seat_only',
  'back_only',
  'full_mattress',
  'half_mattress',
  'relax',
  'other'
]
import { authComputed } from '@/state/helpers'

export default {
  name: 'shared.reference.step',
  props: {
    value: { type: Object, default: () => {} }
  },
  data: vm => ({
    MODEL_TYPES,
    isLoading: false,
    allow_duplicate_ref: false,
    form: {
      reference: '',
      file_id: null,
      specs: {
        model_type: null,
        other_model_type: null,
        is_remill: false
      },
      ...vm.value
    }
  }),
  computed: {
    ...authComputed,
    modelTypes () {
      var arr = [
        {
          text: this.$t(`attribute.model_type.select_model_type`),
          value: null
        }
      ]
      return [
        ...arr,
        ...MODEL_TYPES.map(t => {
          return {
            text: this.$t(`attribute.model_type.${t}`),
            value: t
          }
        })
      ]
    }
  },
  validations: {
    form: {
      reference: {
        required,
        isUniqueReference: async function (value) {
          if (this.userProfile.preferences.allow_duplicate_references)
            return true

          // standalone validator ideally should not assume a field is required
          if (value === '') return true

          return await api.webForms.isUniqueReference({ reference: value })
        }
      },
      specs: {
        model_type: {
          required
        },
        other_model_type: {
          required: requiredIf(model => model.model_type === 'other')
        }
      }
    }
  },
  methods: {
    async validate () {
      if (!this.$v && !this.$v.form) return true

      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.isLoading = true
        try {
          if (!this.form.specs.is_remill)
            await this.$refs['file-uploader'].uploadFileAsync()
          this.$emit('validated', { ...this.form })
          this.$emit('input', { ...this.form })
          this.isLoading = false
          return true
        } catch (error) {
          this.isLoading = false
          console.error(error)
          return false
        }
      } else {
        return !this.$v.form.$invalid
      }
    }
  }
}
</script>
<template>
  <b-card no-body class="shadow-none">
    <div class="d-flex align-items-start">
      <g-form-error-wrapper
        :validations="$v.form.specs.model_type"
        style="width: 300px"
      >
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model="form.specs.model_type"
            :label="$t('Model Type')"
            :description="$t('what best describes your model?')"
            :options="modelTypes"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.model_type.$touch()"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper
        :validations="$v.form.specs.other_model_type"
        v-if="form.specs.model_type === 'other'"
        class="ml-2"
        style="width: calc(100% - 300px)"
      >
        <template v-slot="{ errors, invalid }">
          <g-text-input
            v-model="form.specs.other_model_type"
            :label="$t('Other Type')"
            :placeholder="$t('Describe what your model is')"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.other_model_type.$touch()"
            label-cols-sm="12"
          >
          </g-text-input>
        </template>
      </g-form-error-wrapper>
    </div>

    <g-form-error-wrapper :validations="$v.form.reference">
      <template v-slot="{ errors, invalid }">
        <g-text-input
          v-model="form.reference"
          :label="$t('Your Reference')"
          :placeholder="$t('Your reference. i.e. po number, patient name')"
          :error-messages="errors"
          :is-valid="!invalid"
          v-on:blur="$v.form.reference.$touch()"
        >
        </g-text-input>
      </template>
    </g-form-error-wrapper>

    <b-form-checkbox
      id="is_remill"
      class=""
      v-model="form.specs.is_remill"
      name="is_remill"
      v-if="userProfile.preferences.allow_remills"
    >
      {{ $t('Remill of previous order?') }}
    </b-form-checkbox>

    <keep-alive>
      <app-single-file-upload
        v-show="!form.specs.is_remill"
        ref="file-uploader"
        v-model="form.file_id"
        :max-size-mb="10"
        :allowed-extensions="['.stl']"
      />
    </keep-alive>
  </b-card>
</template>
